<div class="radio-check">
  <rt-icon [name]="icon()" size="small" layout layout-align-items-center layout-justify-center="" />
</div>
<div>
  <div class="label">
    {{ item.option }}
  </div>
  @if (item.description) {
    <div class="description">
      {{ item.description }}
    </div>
  }
</div>
